import { render, staticRenderFns } from "./PatientAssistTab.vue?vue&type=template&id=1cb07336&scoped=true"
import script from "./PatientAssistTab.vue?vue&type=script&lang=js"
export * from "./PatientAssistTab.vue?vue&type=script&lang=js"
import style0 from "./PatientAssistTab.vue?vue&type=style&index=0&id=1cb07336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb07336",
  null
  
)

export default component.exports